<template>
  <div
    :data-id="dataId"
    class="flex items-center"
    :class="{ 'justify-center': !perPage, 'justify-between': perPage }"
  >
    <div
      :data-id="dataId"
      v-if="perPage"
      class="flex items-center gap-2 flex-shrink-0 w-72"
    >
      <BlTextBody1 :data-id="dataId" text="Show" />
      <BlSelectBox
        :dataId="dataId"
        dense
        class="max-w-20"
        :placeholder="`${cPerPage}`"
        v-model="cPerPage"
        :options="[
          { label: '25', value: 25 },
          { label: '50', value: 50 },
          { label: '100', value: 100 }
        ]"
        @change="cPerPage = $event"
      />
      <BlTextBody1 :data-id="dataId" :text="`from ${total} results`" />
    </div>
    <div :data-id="dataId" class="flex items-center">
      <div
        :data-id="dataId"
        class="h-10 w-10 flex items-center justify-center bg-pure-white hover:bg-slate-300 rounded-l border border-slate-500 cursor-pointer"
        :class="{ 'pointer-events-none': cPage === 1 }"
        :disabled="cPage === 1"
        @click="cPage--"
      >
        <BlIcon
          :dataId="dataId"
          icon="chevron-left"
          class="h-5 w-5"
          :class="{ 'opacity-50': cPage === 1 }"
        />
      </div>
      <div
        :data-id="dataId"
        v-for="(n, i) in pages"
        :key="i"
        class="h-10 w-10 flex items-center justify-center bg-pure-white hover:bg-slate-300 border border-slate-500 cursor-pointer"
        :class="{ 'bg-slate-300': cPage === n }"
        @click="cPage = n"
      >
        <BlTextBody2 :data-id="dataId" :text="n || '...'" />
      </div>
      <div
        :data-id="dataId"
        class="h-10 w-10 flex items-center justify-center bg-pure-white hover:bg-slate-300 rounded-r border border-slate-500 cursor-pointer"
        :class="{ 'pointer-events-none': cPage === cCount || cCount === 0 }"
        :disabled="cPage === cCount || cCount === 0"
        @click="cPage++"
      >
        <BlIcon
          :dataId="dataId"
          icon="chevron-right"
          class="h-5 w-5"
          :class="{ 'opacity-50': cPage === cCount || cCount === 0 }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BlIcon from "./BlIcon.vue";
import BlInputButton from "./BlInputButton.vue";
import BlSelectBox from "./BlSelectBox.vue";
import BlTextBody1 from "./BlTextBody1.vue";
import BlTextBody2 from "./BlTextBody2.vue";
import BlTextSubtitle3 from "./BlTextSubtitle3.vue";
export default {
  components: {
    BlInputButton,
    BlTextSubtitle3,
    BlIcon,
    BlTextBody2,
    BlTextBody1,
    BlSelectBox
  },
  props: {
    dataId: { type: String, default: "" },
    count: { type: Number, required: false },
    page: { type: Number, required: false },
    perPage: { type: Number, required: false },
    total: { type: Number, required: false, default: 0 }
  },
  data() {
    return {
      cPage: 1,
      cPerPage: 25
    };
  },
  watch: {
    page(val, old) {
      if (Number(val) === Number(old)) return;
      this.cPage = Number(val);
    },
    cPage(val, old) {
      if (Number(val) === Number(old)) return;
      this.$emit("changed", Number(val));
    },
    perPage(val, old) {
      if (Number(val) === Number(old)) return;
      this.cPerPage = Number(val);
    },
    cPerPage(val, old) {
      if (Number(val) === Number(old)) return;
      this.$emit("changed-per-page", Number(val));
    }
  },
  mounted() {
    if (this.page) this.cPage = this.page;
    if (this.perPage) this.cPerPage = this.perPage;
  },
  computed: {
    ...mapGetters(["currentCenter"]),
    cCount() {
      return this.count ? this.count : Math.ceil(this.total / this.perPage);
    },
    pages() {
      if (this.cCount <= 7) {
        const pages = [];
        for (let i = 1; i <= this.cCount; i++) {
          pages.push(i);
        }
        return pages;
      }
      let before = [];
      let after = [];

      if (this.cPage <= 4) {
        before = [1, 2, 3, 4];
        after = [5, null, this.cCount];
      } else if (this.cCount - this.cPage < 4) {
        before = [1, null, this.cCount - 4];
        after = [
          this.cCount - 3,
          this.cCount - 2,
          this.cCount - 1,
          this.cCount
        ];
      } else {
        for (let i = 1; i <= this.cPage; i++) {
          before.push(i);
        }
        for (let i = before[before.length - 1] + 1; i <= this.cCount; i++) {
          after.push(i);
        }
        if (before.length >= 5) {
          before = [
            1,
            null,
            before[before.length - 2],
            before[before.length - 1]
          ];
        }
        if (after.length >= 4) {
          after = [after[0], null, after[after.length - 1]];
        }
      }

      return [...before, ...after];
    }
  }
};
</script>

<style scoped lang="scss">
.bl-input-component {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .bl-input-page-container {
    position: relative;
    display: flex;
    gap: 0.25rem;
    align-items: center;
    .bl-input-page {
      cursor: pointer;
      position: relative;
      width: 2rem;
      height: 2rem;
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      &.bl-input-page-active {
        background: var(--light-purple-one);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BlInputPagination.vue